// extracted by mini-css-extract-plugin
module.exports = {"container":"SellerBadge_container__1RV0V"};